import React from 'react';
import IconListItemView from './IconListItem';
import { IconListItem } from '../../types';

interface Props {
    items: Array<IconListItem>,
    baseCol?: number,
    largeCol?: number,
}

const iconList: React.FunctionComponent<Props> = ({ items, baseCol, largeCol }: Props) => {
    const colProps: {
        baseCol?: number,
        largeCol?: number,
    } = {};
    if (baseCol) colProps.baseCol = baseCol;
    if (largeCol) colProps.largeCol = largeCol;

    return (
        <div className="category-list grid row">
            {items.map(item => (
                <IconListItemView
                    key={item.id}
                    item={item}
                    {...colProps}
                />
            ))}
        </div>
    );
};

export default iconList;
